// componentes
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

// interfaces 
import { IPedido } from 'src/app/interfaces/pedido';
import { IAvisos } from 'src/app/interfaces/avisos';

// servicios
import { ModalAvisoPedidoService } from '../../services/modal-pedido-aviso.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { IAvisosOpciones } from 'src/app/pages/tablas/avisos/avisosListOpciones';
import { AvisosService } from 'src/app/services/datos/avisos.service';


@Component({
  selector: 'app-modal-pedido-avisos',
  templateUrl: './modal-pedido-avisos.component.html',
  styleUrls: ['./modal-pedido-avisos.component.scss']
})
export class ModalPedidoAvisosComponent implements OnInit {
 
  loading: boolean = false;

  constructor(
    public modalAvisoPedidoSrv: ModalAvisoPedidoService,
    private avisosSrv: AvisosService,
    private notificSrv: NotificacionesService
  ) { }


  ngOnInit(): void {
    console.log('__ModalPedidoAvisosComponent.ngOnInit()  this.modalAvisoPedidoSrv.avisosList', this.modalAvisoPedidoSrv.avisosList); 
  }

  cerrarModal() {
    this.modalAvisoPedidoSrv.cerrarModal();
  }

  cerrarModalClickOutside(event: MouseEvent) {
    // Cerrar modal al hacer click fuera del modal  
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.cerrarModal();
    }
  }





  ///   AUX   ///



}
